import React from 'react';
import Icon from './Icon';
import styles from '../../styles/components/EmptyState.module.css';

function EmptyState({ icon = 'inbox', title, description, children, noBorder = false }) {
  const classes = [styles.emptyState, noBorder && styles.noBorder].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <Icon name={icon} size={48} className={styles.icon} />
      {title && <h3 className={styles.title}>{title}</h3>}
      {description && <p className={styles.description}>{description}</p>}
      {children}
    </div>
  );
}

export default EmptyState;
